import {
  registerComponent,
  replaceDOM,
  asyncRequest,
  debounce,
  loading,
} from "helpers";

registerComponent(
  "cart-items",
  class CartItems extends HTMLElement {
    SECTIONS_TO_RENDER = [
      {
        name: "cart-count",
        selector: "[data-cart-count]",
      },
      {
        name: "cart",
        selector: "[data-cart-items]",
      },
      {
        name: "cart",
        selector: "[data-cart-totals]",
      },
      {
        name: "cart",
        selector: "[data-cart-checkout]",
      },
      {
        name: "cart",
        selector: "[data-cart-recommendations]",
      },
    ];

    constructor() {
      super();

      this.removeButtons = this.querySelectorAll("[data-remove-item-button]");
      this.form = this.querySelector("form");
      this.currentItemCount = Array.from(
        this.querySelectorAll('[name="updates[]"]')
      ).reduce(
        (total, quantityInput) => total + parseInt(quantityInput.value, 10),
        0
      );

      this.removeButtons.forEach((button) => {
        button.addEventListener("click", this.remove.bind(this));
      });

      const debouncedChangeHandler = debounce((event) => {
        this.handleChange(event);
      }, 300);

      this.form?.addEventListener("change", debouncedChangeHandler);
    }

    remove(event) {
      const line = event.currentTarget.dataset.removeItemButton;

      event.preventDefault();

      this.updateQuantity(line, 0);
    }

    handleChange(event) {
      this.updateQuantity(
        event.target.dataset.lineItemIndex,
        event.target.value
      );
    }

    getSectionNames() {
      return [
        ...new Set(this.SECTIONS_TO_RENDER.map((section) => section.name)),
      ];
    }

    async updateQuantity(line, quantity) {
      const body = {
        line,
        quantity,
        sections: this.getSectionNames(),
        sections_url: window.location.pathname,
      };
      const options = {
        ...WYATT.config.fetch.post,
        ...{ body: JSON.stringify(body) },
      };

      loading.add(this);

      const response = await asyncRequest(
        WYATT.routes.cart_change_url,
        options,
        {
          messageOptions: {
            dismiss: false,
            appendPoint:
              '[data-mini-cart][active="true"] [data-drawer-messages], #page-messages',
          },
        }
      );

      if (response) {
        this.handleSuccessfulUpdate(response);
      }

      loading.remove(this);
    }

    handleSuccessfulUpdate(state) {
      const parsedState = JSON.parse(state);

      this.SECTIONS_TO_RENDER.forEach((section) =>
        replaceDOM(parsedState.sections[section.name], section.selector)
      );
    }
  }
);
